/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M75.5 24C47.006 24 24 47.006 24 75.5S47.006 127 75.5 127 127 103.994 127 75.5 103.994 24 75.5 24zm-6.989 48.857L68.741 50H82.26l.23 22.857L90 71.143 75.443 90 61 71.143l7.511 1.714zM102 101H50v-6h52v6z" _fill="#C4FFF9" fill-rule="evenodd"/>'
  }
})
